var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_461_852)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.4924 36.5507C21.9123 38.0812 13.8921 38.8473 5.73448 36.5507C2.55728 35.6565 0 33.6674 0 30.8125C0 27.9316 2.6478 26.1156 5.8153 25.0649C12.3548 22.8947 19.6403 22.6331 27.4115 25.0649C30.5984 26.0619 33.2269 27.9316 33.2269 30.8125C33.2269 33.6674 30.6777 35.6771 27.4924 36.5507Z",
    fill: "#62C776",
    fillOpacity: 0.57
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6134 20.8685C22.5047 20.8685 27.2805 16.1969 27.2805 10.4342C27.2805 4.67157 22.5047 0 16.6134 0C10.722 0 5.94617 4.67157 5.94617 10.4342C5.94617 16.1969 10.722 20.8685 16.6134 20.8685Z",
    fill: "#62C776",
    fillOpacity: 0.57
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4847 13.686C36.8882 13.199 36.0129 13.2923 35.5303 13.8939L31.5538 18.8493L29.9866 17.5709C29.3707 17.0689 28.4679 17.1646 27.97 17.7852C27.4722 18.4058 27.5675 19.3166 28.1826 19.8186L30.7835 21.9405C30.904 22.0386 31.0349 22.1129 31.1723 22.1659C31.7292 22.4038 32.396 22.2552 32.7952 21.7579L37.6908 15.6561C38.1733 15.0545 38.0812 14.1722 37.4847 13.6852V13.686Z",
    fill: "#62C776",
    fillOpacity: 0.57
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_461_852"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivo);
export default __webpack_public_path__ + "static/media/activo.11cf45feba1a3c6e2ea44d074c74fb1d.svg";
export { ForwardRef as ReactComponent };